import { Typography } from "@/design-system/Atoms";
import { HowItWorksStepCard } from "@/design-system/Molecules";
import { useInViewOnce } from "@/hooks/useInViewOnce";

import type { FC } from "react";

interface CardData {
  icon?: string;
  title?: string;
  description?: string;
  className?: string;
}
interface HomeHowItWorksSectionProp {
  heading?: string;
  highlightedHeadingMain?: string;
  highlightedHeadingAccent?: string;
  items?: CardData[];
}

const HomeHowItWorksSection: FC<HomeHowItWorksSectionProp> = ({
  heading,
  items,
  highlightedHeadingMain,
  highlightedHeadingAccent,
}) => {
  const { ref, isVisible } = useInViewOnce<HTMLDivElement>();

  return (
    <section className="pt-40 ">
      <div className="container mx-auto  px-4">
        <div className="flex flex-col lg:flex-row gap-10">
          <div
            ref={ref}
            className={`lg:w-5/12 transition-opacity duration-700 ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"
              }`}
          >
            <div className="sticky top-0 space-y-6">
              <Typography variant="categoryText" as="h2" className="mb-10">
                {heading}
              </Typography>
              <Typography variant="sectionHeading" as="h2" className="mb-4">
                <>
                  {highlightedHeadingMain}{" "}
                  <span className="text-[#8793a9]">
                    {highlightedHeadingAccent}
                  </span>
                </>
              </Typography>
            </div>
          </div>

          <div className="lg:ml-auto lg:w-6/12 space-y-6">
            {items?.map((step, idx) => (
              <HowItWorksStepCard
                key={idx}
                icon={step.icon ?? ""}
                title={step.title ?? ""}
                description={step.description ?? ""}
                className={step.className ?? ""}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHowItWorksSection;
